
export const environment = {
    production: true,
    API_ENDPOINT: 'https://api.smartpricing.costa-platform-staging.com/api/',
    CLIENT_ID: '6bfb19b5-71b5-482e-977d-b54d2f4c095b',
    TENANT_ID: '04ed63ba-9902-48da-b4cd-52b94b3a487e',
    REDIRECT_URL: 'https://smartpricing.costa-platform-staging.com/',
    AUDIANCE: 'api://6d28b07d-1ee3-4f28-a454-3c4f1b11141b/pricing-app-scope',
    IS_AUTHENTICATED:true
  };